export enum ClientListFilter {
    ClientStatusFilter = 1,
    ClientEnabledFilter = 2,
}